import { MARKETS_BY_CODE } from "@/i18n/markets";

const ENTRY_KEY = "bac:checkout-route-entry";
const REPORTED_KEY = "bac:checkout-route-reported";
const ENTRY_TTL_MS = 2 * 60_000;

// Only a timestamp is stored. Neither the handoff token nor the URL is ever
// persisted in the operational signal.
export function markCheckoutRouteEntry(): void {
  try { sessionStorage.setItem(ENTRY_KEY, String(Date.now())); } catch {}
}

export function clearCheckoutRouteEntry(): void {
  try { sessionStorage.removeItem(ENTRY_KEY); } catch {}
}

export function checkoutRouteFailure(pathname: string, now = Date.now()):
  { type: "checkout_entry_not_found" | "malformed_checkout_prefix"; market: string } | null {
  const parts = pathname.split("/").filter(Boolean).map((p) => p.toLowerCase());
  const market = Object.prototype.hasOwnProperty.call(MARKETS_BY_CODE, parts[0]) ? parts[0] : "unknown";
  const offset = market === "unknown" ? 0 : 1;
  const malformed = parts[offset] === parts[0] && market !== "unknown" && parts[offset + 1] === "checkout";
  let entryRecent = false;
  try {
    const ts = Number(sessionStorage.getItem(ENTRY_KEY));
    entryRecent = ts > 0 && now >= ts && now - ts <= ENTRY_TTL_MS;
  } catch {}
  if (!malformed && !entryRecent) return null;
  return { type: malformed ? "malformed_checkout_prefix" : "checkout_entry_not_found", market };
}

export function reportCheckoutRouteFailure(pathname: string): void {
  const failure = checkoutRouteFailure(pathname);
  if (!failure) return;
  try {
    // One signal per tab / market / type over 15 minutes; a retrying 404
    // cannot independently meet the two-renter alert threshold.
    const key = `${REPORTED_KEY}:${failure.market}:${failure.type}`;
    const last = Number(sessionStorage.getItem(key));
    if (last > 0 && Date.now() - last < 15 * 60_000) return;
    sessionStorage.setItem(key, String(Date.now()));
    sessionStorage.removeItem(ENTRY_KEY);
  } catch { /* Storage denial does not block navigation. */ }
  try {
    void fetch(`${import.meta.env.BASE_URL || "/"}api/ops/checkout-route-failure`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(failure),
      keepalive: true,
      credentials: "same-origin",
      referrerPolicy: "no-referrer",
    }).catch(() => {});
  } catch { /* Best effort, never interrupt the renter. */ }
}